import React from 'react';

const formErrorLock = 'https://storage.googleapis.com/fplsblog/Form_error_images/form_error_lock.png';

const ErrorImage = ({ imageLink }) => {
  return <img src={imageLink || formErrorLock} alt="Error Message" height={110} />;
};

export default ErrorImage;
